var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipelines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#283EB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 55H64V58H55V53.5H58V50.5H55V43C55 42.2044 54.6839 41.4413 54.1213 40.8787C53.5587 40.3161 52.7956 40 52 40H40V37H37V49H40V46H49V50.5H46V53.5H49V61C49 61.7956 49.3161 62.5587 49.8787 63.1213C50.4413 63.6839 51.2044 64 52 64H64V67H67",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelines);
export default __webpack_public_path__ + "static/media/pipelines.a69a93d57c4d628b0ab82b8433e5c260.svg";
export { ForwardRef as ReactComponent };